import { Collapse, CollapseProps } from 'antd';
import ArrowDownIcon from '@/assets/imgs/arrow_down.svg?react';
import ArrowUpIcon from '@/assets/imgs/arrow_up.svg?react';

const BaseCollapse = (props: CollapseProps & {
  panelColor?: string;
  dividerColor?: string;
}) => {
  const panelStyle: React.CSSProperties = {
    marginBottom: '8px',
    background: props.panelColor || '#F7F8FA',
    borderRadius: '8px',
    border: 'none',
  };
  const items = props.items;
  items?.forEach((item) => {
    item.style = panelStyle;
  });
  return (
    <Collapse
      expandIcon={(val) => {
        const { isActive } = val;
        if (isActive) return <ArrowUpIcon />;
        return <ArrowDownIcon />;
      }}
      bordered={false}
      expandIconPlacement="end"
      style={{
        background: 'transparent',
      }}
      styles={{
        root: {
          background: 'transparent',
        },
        body: {
          borderTop: props.dividerColor ? `1px solid ${props.dividerColor}` : undefined,
          padding: '14px 12px'
        }
      }}
      items={items}
      {...props}
    />
  );
};
export default BaseCollapse;
